<template>
  <div class="process-dialog-inform">
    <el-dialog class="process-inform-dialog" title="节点属性" :visible.sync="inform.dialogVisible" center width="600px" @open="open" :close-on-click-modal="false" append-to-body>
      <div class="modal-body">
        <el-switch class="notice-switch" v-model="noticeSwitch" inactive-text="通知设置"></el-switch>
        <div class="all-notice">
          <div v-for="(item,index) in inform.notice" :key="index" class="item-notice">
          <div class="title">通知设置{{index+1}} <i class="el-icon-close close"  @click="delNotice(index)"></i></div>
          <div>
            <div class="left"><span>通知方式</span></div>
            <div class="right">
              <el-checkbox-group v-model="item.ways">
              <el-checkbox label="email">邮件</el-checkbox>
              <el-checkbox label="app">APP</el-checkbox>
              <el-checkbox label="message">短信</el-checkbox>
            </el-checkbox-group>
            </div>
          </div>
          <div>
            <div class="left"><span>通知内容</span></div>
            <div class="right">
              <el-checkbox :value="item.selectContent==='defaultContent'"  @change="item.selectContent='defaultContent'">默认内容</el-checkbox>
              <el-checkbox :value="item.selectContent!=='defaultContent'"  @change="item.selectContent='customContent'">自定义内容</el-checkbox>
            </div>
          </div>
          <div v-show="item.selectContent==='defaultContent'">
            <div><span>示列</span></div>
            <div class="right">
              <div class="content">
                <p>流程处理提醒(某某某)</p>
                <p>某某某在某某时间向您发起了某某流程，请及时处理</p>
                <a>详情</a>
              </div>
            </div>
          </div>
          <div v-show="item.selectContent==='customContent'" class="inform-custom">
            <div class="inform-custom-content">
              <p>通知主题</p>
              <div :class="['theme', {'warning': validateFlag}]" contenteditable ref="informTheme" @blur="saveCursor('theme',index)" v-html="prcessTitleHtml(item)"></div>
              <p>通知内容</p>
              <div :class="['content', {'warning': validateFlag}]" contenteditable ref="informContent"
                @blur="saveCursor('',index)" v-html="noticeTemplate(item)"></div>

            </div>
            <div class="inform-custom-data">
              <div>
                  <span>选择节点</span>
                  <el-select v-model="selectNodeId" placeholder="选择节点">
                    <el-option
                      v-for="item in nodes"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                    </el-option>
                </el-select>
              </div>
              <div>
                <p>选择数据</p>
                <el-menu class="el-menu-vertical">
                <div v-for="component in selectNodeComponents" :key="component.id">
                  <el-menu-item
                                :index="component.id"
                                :name="component.name"
                          @click="addParam(component.archive.columnId,component.name,index)" >{{component.name}}
                  </el-menu-item>
                </div>
              </el-menu>
              </div>
            </div>
          </div>
          <div class="select-inform-people">
            <ul>
              <li>通知节点处理人</li>
              <li>
                <el-select v-model="item.targetNode" multiple collapse-tags  placeholder="选择节点">
                  <el-option
                    v-for="item in nextNode"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </li>
              <li>
                <span v-if="selectNodes.length === 0">无</span>
                <span v-for="(node,index) in selectNodes(item)" :key='index'>{{node.name}}<i v-if="index!==selectNodes.length-1">,</i></span>
              </li>
            </ul>
            <ul>
              <li>通知固定用户</li>
              <li class="choose-consumer">
                <span @click="openDialogCustom(item)">选择用户</span>
              </li>
              <li>
                <span v-if="item.targetUser&&item.targetUser.length===0">无</span>
                <span v-for="(consumer,index) in item.targetUser&&item.targetUser" :key='consumer.targetId'>{{consumer.name}}<i v-if="index!==item.targetUser.length-1">,</i> </span>
              </li>
            </ul>
            <ul>
              <li>通知节点内人员</li>
              <li class="choose-node-person">
                <span @click="openDialogNode(item)">选择控件</span>
              </li>
              <li>
                <span v-if="item.targetComponent&&item.targetComponent.length===0">无</span>
                <span v-for="(component,index) in item.targetComponent&&item.targetComponent" :key='component.targetId'>{{getComponentParentById(component.targetId)}}-{{component.name}}<i v-if="index!==item.targetComponent.length-1">,</i></span>
              </li>
            </ul>
          </div>
          </div>
        </div>
        <el-button class="add-notice" type="text" @click="addNotice"><i>+</i> 添加通知设置</el-button>
        <div class="time">
          <el-form :inline="true">
            <el-form-item label="自动流转:">
              <el-select v-model="inform.connection.timing.isTiming" :disabled="currentTaskNode.type==='inclusiveGateway_start'||currentTaskNode.type==='inclusiveGateway_end'">
                <el-option v-if="this.processService.processDefinition.process.startNode!==this.currentTaskNode.id" label="上一节点完成时" value="1"></el-option>
                <el-option label="无触发" value="0"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="" v-if="inform.connection.timing.isTiming==='1'" class="specific-time">
                <el-input type="number" v-model="inform.connection.timing.hour" min="0"> <template slot="append">时</template></el-input>
                <el-input type="number" v-model="inform.connection.timing.minute" min="0" max="60"> <template slot="append">分</template></el-input>
                <el-input type="number" v-model="inform.connection.timing.second" min="0" max="60"> <template slot="append">秒</template></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveNotice">确 定</el-button>
        <el-button @click="inform.dialogVisible = false">取 消</el-button>
      </div>
    </el-dialog>
    <process-dialog-select-custom
      :dialogVisible="selectCustomDialog.dialogVisible"
      :allData="selectCustomDialog.allData"
      :candidates="selectCustomDialog.targetUser"
      @closeCustomDialog="closeCustomDialog"
      @saveSelectCustom="saveSelectCustom">
    </process-dialog-select-custom>
    <process-dialog-select-node
      :dialogVisible="selectNodeDialog.dialogVisible"
      :allData="selectNodeDialog.allData"
      :candidates="selectNodeDialog.targetComponent"
      @closeNodeDialog="closeNodeDialog"
      @saveSelectNode="saveSelectNode">
    </process-dialog-select-node>
  </div>
</template>

<script>
import Notice from '@/store/process/notice'
import {ColumnComponent} from '@/store/form/component'
import ProcessDialogSelectCustom from './process-dialog-select-custom'
import ProcessDialogSelectNode from './process-dialog-select-node'
export default {
  name: 'ProcessSelectInform',
  props: ['inform', 'nodes', 'currentTaskNode'],
  inject: ['processService'],
  components: {
    ProcessDialogSelectCustom,
    ProcessDialogSelectNode
  },
  data () {
    let noticeSwitch = this.inform.connection.notice[0].enable
    return {
      informContent: '默认内容',
      selectNodeId: '',
      selectConsumer: [],
      cacheRange: '',
      selectCustomDialog: {
        dialogVisible: false,
        allData: [],
        noticeId: '',
        targetUser: []
      },
      selectNodeDialog: {
        dialogVisible: false,
        allData: [],
        noticeId: '',
        targetComponent: []
      },
      // 自定义内容校验结果标志
      validateFlag: false,
      noticeSwitch: noticeSwitch
    }
  },

  computed: {
    nextNode () {
      return this.processService.processDefinition.process.nodes
    },

    selectNodeComponents () {
      if (this.selectNodeId) {
        let selectNodeFormId = this.nodes.find(n => n.id === this.selectNodeId).formId
        let selectNodeComponents = this.processService.formService.getComponentById(selectNodeFormId).archivedChildren
        return selectNodeComponents
      }
    }
  },
  methods: {
    selectNodes (item) {
      let selectNodes = []
      item.targetNode && item.targetNode.forEach(m => {
        let node = this.nextNode.find(n => n.id === m)
        node && selectNodes.push(node)
      })
      return selectNodes
    },
    open () {
      let nextNode = this.nextNode[0]
      if (nextNode) {
        this.inform.notice.targetNode = this.inform.notice.targetNode.length !== 0 ? this.inform.notice.targetNode : [nextNode.id]
      }
    },
    templateToWithCode (template) {
      template.match(/\$\{(.+?)\}/g) && template.match(/\$\{(.+?)\}/g).map((el) => {
        let dataId = el.replace(/[${}]/g, '').split(',')[0]
        let name = el.replace(/[${}]/g, '').split(',')[1]
        let code = `&nbsp;<code contenteditable='false' dataId=${dataId} name=${name}>${name}</code>&nbsp;`
        template = template.replace(el, code)
      })
      return template
    },
    prcessTitleHtml (item) {
      if (item.selectContent === 'defaultContent') {
        item.processTitle = ''
      }
      return this.templateToWithCode(item.processTitle)
    },
    noticeTemplate (item) {
      let content = ''
      // 这个processName只是为了让content的内容是${peocessName}不走templateToWithCode这个方法
      let processName = 'processName'
      if (item.template && item.selectContent === 'customContent') {
        content = item.template.slice(0)
        if (!content.includes(processName)) {
          content = this.templateToWithCode(content)
        } else {
          content = ''
        }
      }
      return content
    },
    addParam (id, name, index) {
      if (!this.cacheRange) {
        this.$message.info('请选择插入的位置')
        return false
      }
      let sel = window.getSelection()
      sel.removeAllRanges()
      sel.addRange(this.cacheRange)

      var html = `&nbsp;<code contenteditable='false' dataId=${id} name=${name}>${name}</code>&nbsp;`
      // 替换选中的内容
      document.execCommand('insertHTML', false, html)
      if (this.cacheRange.focusNode.className === 'content' || this.cacheRange.focusNode.parentElement.className === 'content') {
        this.selectParam(this.$refs.informContent[index])
      } else {
        this.selectParam(this.$refs.informTheme[index])
      }
    },
    selectParam (selector) {
      selector.focus()
    },
    saveCursor (type, index) {
      let templateString = this.$refs.informTheme[index].innerHTML
      templateString && templateString.match(/<code(.+?)<\/code>/g) && templateString.match(/<code(.+?)<\/code>/g).map((el) => {
        let name = el.match(/name="(.+?)"/g).toString()
        let newstr = el.replace(el, name.slice(6, name.length - 1))
        templateString = templateString.replace(el, newstr).replace(/&nbsp;/g, '')
      })
      if (type === 'theme' && templateString.length > 50) {
        this.$message({
          type: 'warning',
          message: '通知主题最多50个字'
        })
      }
      let sel = window.getSelection()
      if (sel.rangeCount) {
        this.cacheRange = sel.getRangeAt(0)
        this.cacheRange.anchorNode = sel.anchorNode
        this.cacheRange.anchorOffset = sel.anchorOffset
        this.cacheRange.focusNode = sel.focusNode
        this.cacheRange.focusOffset = sel.focusOffset
      }
    },

    getTemplateString (templateString) {
      templateString && templateString.match(/<code(.+?)<\/code>/g) && templateString.match(/<code(.+?)<\/code>/g).map((el) => {
        let dataId = el.match(/dataid="(.+?)"/g).toString()
        let name = el.match(/name="(.+?)"/g).toString()
        let newstr = el.replace(el, '${' + dataId.slice(8, dataId.length - 1) + ',' + name.slice(6, name.length - 1) + '}')
        templateString = templateString.replace(el, newstr).replace(/&nbsp;/g, '')
      })
      return templateString
    },
    saveNotice () {
      this.inform.notice.forEach((m, index) => {
        m.enable = this.noticeSwitch
        let theme = this.getTemplateString(this.$refs.informTheme[index] && this.$refs.informTheme[index].innerHTML) || ''
        let content = this.getTemplateString(this.$refs.informContent[index] && this.$refs.informContent[index].innerHTML) || 'processName'
        let startName = 'startName'
        let startTime = 'startTime'
        let template = ''
        if (m.selectContent === 'defaultContent') {
          template = '${' + startName + '}在${' + startTime + '}向您发起了${' + content + '}流程，请及时处理'
          theme = '流程处理提醒(${' + startName + '})'
        } else {
          // 校验通知内容自定义时主题、内容必填 (<br>edge中解析dom时会出现,原因不明)
          if (!theme.replace(/(&nbsp;|&ensp;|&emsp;|&thinsp;|<br>|\s)*/g, '') || !content.replace(/(&nbsp;|&ensp;|&emsp;|&thinsp;|<br>|\s)*/g, '') || content === 'processName') {
            this.validateFlag = true
            let time = setTimeout(() => {
              this.validateFlag = false
              clearTimeout(time)
            }, 1000)
            return this.$message.warning('自定义内容时,通知主题和内容不能为空')
          }
          template = `${content}`
        }
        m.template = template
        m.processTitle = theme
      })
      this.processService.saveNotice({connectionId: this.inform.connectionId, notice: this.inform.notice})
      this.processService.saveConnectionTimng({connectionId: this.inform.connectionId, timing: this.inform.connection.timing})

      this.inform.dialogVisible = false
    },

    saveSelectCustom (param) {
      let notice = this.inform.notice.find(m => m.id === this.selectCustomDialog.noticeId)
      notice.targetUser = param.candidates
      this.closeCustomDialog()
    },
    saveSelectNode (param) {
      let notice = this.inform.notice.find(m => m.id === this.selectCustomDialog.noticeId)
      notice.targetUser = param.candidates
      this.closeNodeDialog()
    },
    openDialogCustom (item) {
      this.selectCustomDialog.dialogVisible = true
      this.selectCustomDialog.noticeId = item.id
      this.selectCustomDialog.targetUser = item.targetUser
    },
    closeCustomDialog () {
      this.selectCustomDialog.dialogVisible = false
      this.selectCustomDialog.noticeId = ''
      this.selectCustomDialog.targetUser = []
    },
    openDialogNode (item) {
      this.selectNodeDialog.allData = this.getComponent()
      this.selectNodeDialog.dialogVisible = true
      this.selectNodeDialog.noticeId = item.id
      this.selectNodeDialog.targetComponent = item.targetComponent
    },
    closeNodeDialog () {
      this.selectNodeDialog.dialogVisible = false
      this.selectNodeDialog.targetComponent = []
      this.selectNodeDialog.noticeId = ''
    },
    getComponentParentById (id) {
      // 编辑的时候取不到设计时候的 this.selectNodeDialog.allData.所以在重新取了一次
      let allData = this.getComponent()
      let component = allData.find(m => {
        if (m.children && m.children.some(c => c.archive.columnId === id)) {
          return m
        }
      })
      if (component) {
        return component.name
      }
    },
    getComponent () {
      let allData = []
      this.processService.formService.getComponentById(this.processService.processDefinition.process.formId).children.forEach(m => {
        let children = this.processService.formService.getComponentById(m.id).archivedChildren.filter(m => m instanceof ColumnComponent)
        allData.push({id: m.id, name: m.name, componentType: m.componentType, children: children})
      })
      return allData
    },
    addNotice () {
      this.inform.notice.push(Notice.create({targetNode: [this.inform.connection.targetNodeId]}))
    },
    delNotice (index) {
      this.inform.notice.splice(index, 1)
    }
  }
}
</script>

<style lang="scss">
.process-inform-dialog {
  .el-dialog--center .el-dialog__body {
    padding: 15px 13px 20px 13px;
    font-size: 12px;
  }

  .modal-body {
    // 为了兼容ie
    text-align: left;

    .all-notice {
      color: #2C2C2C;
      height: 450px;
      overflow: auto;
      margin: 10px 0;
     .item-notice {
      border: 1px solid #DBDBDB;
      border-radius: 4px;
      margin-bottom: 10px;
      .title {
        background: var(--light-9, #EBF5FF);
        height: 27px;
        line-height: 27px;
        padding-left: 8px;
        position: relative;
        margin-bottom: 10px;

        .close {
          position: absolute;
          top: 7px;
          right: 10px;
          color: var(--light-1, #6BB7F3);
          cursor: pointer;
          &:hover {
            color: #FF2828;
          }
        }
      }
      >div:not(.title) {
        margin-left: 14px;
        margin-right: 14px;
        margin-bottom: 20px;

      &.inform-custom {
        overflow: hidden;
        height: 278px;

        .inform-custom-content {
          width: 54%;
          float: left;
          position: relative;

          >div {
            width: 273px;
            border: 1px solid rgba(194, 195, 196, 1);
            border-radius: 4px;
            margin-top: 12px;
            margin-bottom: 16px;
            overflow: auto;

            code {
              padding: 2px 4px;
              font-size: 90%;
              color: #c7254e;
              background-color: #f9f2f4;
              border-radius: 4px;
            }
          }

          .theme {
            height: 74px;
          }

          .content {
            height: 112px;
          }

          .warning {
            animation:bordercolor 1s 3;
            -webkit-animation:bordercolor 1s 1;
          }
          @keyframes bordercolor {
            0% {border-color: #c2c3c4;}
            30% {border-color: #f56c6c;}
            50% {border-color: #c2c3c4;}
            70% {border-color: #f56c6c;}
            100% {border-color: #c2c3c4;}
          }
          @-moz-keyframes bordercolor /* Firefox */
          {
            0% {border-color: #c2c3c4;}
            30% {border-color: #f56c6c;}
            50% {border-color: #c2c3c4;}
            70% {border-color: #f56c6c;}
            100% {border-color: #c2c3c4;}
          }

          @-webkit-keyframes bordercolor /* Safari 和 Chrome */
          {
            0% {border-color: #c2c3c4;}
            30% {border-color: #f56c6c;}
            50% {border-color: #c2c3c4;}
            70% {border-color: #f56c6c;}
            100% {border-color: #c2c3c4;}
          }
        }

        .inform-custom-data {
          width: 46%;
          float: left;
          padding-left: 16px;

          .el-select {
            width: 150px;
            margin-left: 12px;
            margin-bottom: 10px;
          }

          .el-menu {
            border: 1px solid #e6e6e6;
            overflow: auto;
            height: 206px;
            border-radius: 4px;
            margin-top: 5px;

            li {
              height: 35px;
              line-height: 35px;

            }
          }
        }
      }

      .left {
        width: 56px;
        float: left;
        margin-right: 20px;
      }

      .right {
        overflow: hidden;

        .el-checkbox {
          margin-left: 0;
          margin-right: 20px;
        }

        .content {
          width: 100%;
          height: 193px;
          border: 1px solid rgba(194, 195, 196, 1);
          border-radius: 4px;
          padding-left: 17px;
          padding-top: 10px;
          -moz-user-select: none;
          -o-user-select: none;
          -webkit-user-select: none;
          -ms-user-select: none;
          user-select: none;
          margin-top: 10px;

          p {
            font-size: 12px;
            line-height: 24px;

            &:nth-child(1) {
              font-size: 14px;
              position: relative;

            }

            &:last-child {
              color: #C2C3C4
            }
          }
        }
      }

      &.select-inform-people {
        >ul {
          margin-bottom: 10px;
          overflow: hidden;
          font-size: 12px;
          li {
            float: left;
            text-align: center;
            font-size: 12px;

            &:nth-child(1) {
              width: 106px;
              text-align: left;
              line-height: 24px;
            }

            &:nth-child(2) {
              width: 130px;
              height: 28px;
              border-radius: 4px;
              margin-right: 20px;

              &.choose-consumer span,
              &.choose-node-person span {
                width: 130px;
                height: 24px;
                line-height: 23px;
                display: inline-block;
                color: #54ABF1;
                border: 1px solid rgba(84, 171, 241, 1);
                border-radius: 4px;
                cursor: pointer;
              }

              .el-select {
                width: 130px;
                height: 24px;

                .el-input__inner {
                  height: 24px;
                  line-height: 24px;
                  color: #54ABF1;
                  border: 1px solid #54ABF1;
                }
              }
            }

            &:nth-child(3) {
              text-align: right;
              font-size: 12px;
            }
          }
        }
      }
    }
    }
    }
    .notice-switch{
      .el-switch__label {
        color: #232323;
      }

    }
    .add-notice {
      text-align: center;
      width: 100%;
    }
    .time {
      margin-top: 18px;
      position: relative;

      .el-form-item__content {
        width: 118px;
      }

      .el-form-item.specific-time {
        .el-form-item__content {
          width: 284px;
        }

        .el-input {
          width: 80px;
          margin-right: 10px;
          .el-input__inner{
            padding-right: 5px;
          }

          .el-input-group__append {
            padding: 0 4px;
          }
        }
      }

    }

  }
}
</style>



// WEBPACK FOOTER //
// src/components/process/design/process-dialog-inform.vue